import "../edit.css";
import { Box } from "../wrapper";
import { InputProps } from "./input.props";

export const Input: React.FC<InputProps> = ({
  show = true,
  label,
  actions,
  error,
  ...props
}) => {
  return (
    <Box
      show={show}
      actions={actions}
      error={error}
      isDisabled={props.disabled ?? false}
    >
      <input
        className={`edit-box ${props.className}`}
        placeholder={label ?? props.placeholder}
        {...props}
      />
    </Box>
  );
};
